import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import ItemsCarousel from 'react-items-carousel';

import { Card } from '../../../common/index';

import classes from './DashboardFavoritesCards.module.scss';
import axios from "axios";

class DashboardFavoritesCards extends Component {
  _isMounted = false;
  state = {
      recent:[],
      activeItemIndex: 0,
      cards:3
  }

  componentDidMount(){
    this._isMounted = true;
      axios.get("dashboard/favorites").then(res =>{
        if (this._isMounted) {
          this.setState({
              recent:res.data.items
          });
        }
      });
      const width = window.innerWidth;
        let cardnum = 3;
        if(width<=750){
          cardnum = 2;
        }
        if(width<=500){
          cardnum = 1;
        }
        this.setState({ cards: cardnum });
      window.addEventListener('resize', ()=>{
        const width = window.innerWidth;
        let cardnum = 3;
        if(width<=750){
          cardnum = 2;
        }
        if(width<=500){
          cardnum = 1;
        }
        this.setState({ cards: cardnum });
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  changeActiveItem = (activeItemIndex) => this.setState({ activeItemIndex });
    
    render() {
        return(
          <div className={classes.Container}>
          <ItemsCarousel
          numberOfCards={this.state.cards}
           gutter={30}
           showSlither={false}
        firstAndLastGutter={false}
        freeScrolling={false}
           requestToChangeActive={this.changeActiveItem}
            activeItemIndex={this.state.activeItemIndex}
            activePosition={'center'}
            leftChevron={ <div className={classes.button}><img src={ require('../../../assets/img/prev.svg')} /></div>}
            rightChevron={<div className={classes.button}><img src={ require('../../../assets/img/next.svg')} /></div>}
            chevronWidth={40}
            classes={{itemWrapper:'cardincarousel',rightChevronWrapper:'nextDash', leftChevronWrapper:'prevDash'}}
          >
            { this.state.recent.map((recentitem)=>{
              const itemnav = recentitem.navigation;
              return(
             <Card onClick={()=>this.props.history.push(`/${itemnav}/${recentitem.id}`)} key={recentitem.id} image={recentitem.image}>
                <h2>{ recentitem.surtitre }</h2>
                <h1>{ recentitem.titre }</h1>
                <p>{ recentitem.specs }<br/>{ recentitem.country }</p>
              </Card>
            )})}
            </ItemsCarousel>
            </div>
        );
    }
}


export default withRouter(DashboardFavoritesCards);
